import { OSType } from 'types';

export interface handleClickLogParams {
  osType: OSType;
  promotionId: number;
  type: string;
}

export const handleClickLog = async ({
  osType,
  promotionId,
  type,
}: handleClickLogParams): Promise<void> => {
  try {
    await fetch('/api/clicks', {
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      method: 'PUT',
      body: JSON.stringify({
        promotionId,
        platform: osType,
        type,
      }),
    });
  } catch (error) {
  //
  }
};
